'use strict'

module.exports = {
  SHA1: 20,
  SHA256: 32,
  SHA512: 64
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/peer-info/node_modules/libp2p-crypto/src/hmac/lengths.js
// module id = HB0D
// module chunks = 0